'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGET_DATA_PROD = exports.WIDGET_DATA_QA = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.buildSpeedCurveWidgetData = buildSpeedCurveWidgetData;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WIDGET_DATA_QA = exports.WIDGET_DATA_QA = {
  '@type': 'V1',
  showingHsBranding: false,
  agentsRestrictedToMaxConcurrentChats: false,
  hasVisitorEmail: false,
  hasVisitorGivenConsentToCommunicate: false,
  hasVisitorGivenConsentToProcess: false,
  sessionId: 'AF-4XhnJS0nD9aHDxb0-Z9ejljTgQ4-giy1b3Rt2rVbw75c12_AZDXYlzYZjCixLkO9z1ShiYLwIlAFQIYjIpE778zaqElec7KAYQcMo4sr8KNSf_jncHMgo6AJ97eZtCRoNiOZYFE90odKvDs9HMYyUQdpe29bWgSYxgylr4aNAwfzAsPYbVO_oYrdCHzGkD_zTz3Wc6cJ4',
  launcherType: 'ICON',
  message: {
    id: 17844,
    exclusionListIds: [],
    inclusionListIds: [],
    targetingRules: [{
      sourceType: 'URL',
      matchType: 'EQUALS',
      queryParam: null,
      matchValue: 'http://twowaychat-99605114.hs-sitesqa.com/sample-offer',
      type: 'INCLUDE',
      createdBy: 'AGENT'
    }, {
      sourceType: 'URL',
      matchType: 'EQUALS',
      queryParam: null,
      matchValue: 'http://www.twowaychat-99605114.hs-sitesqa.com/sample-offer',
      type: 'INCLUDE',
      createdBy: 'AGENT'
    }],
    exclusionUrls: [],
    inclusionUrls: [],
    targetedMessageSource: 'LIVE_CHAT',
    active: true,
    name: 'Two Way Chat Test',
    initialMessage: 'Have any questions? Happy to help!',
    initialBotResponder: null,
    targetAudienceType: 'ALL_VISITORS',
    rotatingToOwner: null,
    fallbackUser: null,
    targetAudienceId: null,
    showAfterElapsedSeconds: null,
    showOnPercentagePageScroll: null,
    customAwayMessage: "I'm away at the moment, but let me know if you have any questions and I'll reply to you soon.",
    inboxId: 251,
    askForEmailMessage: 'Don’t have time to wait for a response? Leave your email to get notified when we reply.',
    teamName: null,
    aboutTeam: null,
    customEmailCaptureDelay: 60000,
    customConsentToCommunicateMessage: null,
    customConsentToProcessMessage: 'By clicking submit below, you consent to allow twowaychat.com to store and process the personal information submitted above to provide you the content requested.',
    consentToCommunicateSubscriptionId: null,
    language: 'en',
    chatHeadingConfig: {
      '@type': 'USERS_AND_TEAMS',
      userIds: [1382166],
      teamIds: []
    },
    clientTriggers: {
      displayOnExitIntent: { enabled: false },
      displayOnTimeDelay: { enabled: false, timeDelaySeconds: 7 },
      displayOnScrollPercentage: { enabled: false, scrollPercentage: 50 }
    },
    hideWhenOffline: false,
    popOpenWelcomeMessage: true,
    popOpenWidget: false,
    gdprExplicitConsentRequired: true,
    gdprConsentToProcessEnabled: false,
    gdprConsentToCommunicateEnabled: false,
    captureVisitorEmailAddress: true,
    popMessageOnSmallScreens: true,
    showOnSmallScreens: true,
    portalId: 99605114,
    creatorId: 1382166,
    lastEditorId: null,
    createdAt: 1526060134293,
    lastEditedAt: 1536342803215,
    deletedAt: 0
  },
  availabilityOptions: {
    awayMessage: null,
    typicalResponseTime: null,
    officeHoursStartTime: null
  },
  sendFrom: [],
  botResponder: null,
  gates: {
    'Chatflows:ClientTriggers': false
  },
  accentColor: '#00a4bd',
  customAwayMessage: "I'm away at the moment, but let me know if you have any questions and I'll reply to you soon.",
  companyName: 'two-way-chat',
  teamName: null,
  aboutTeam: null,
  messagesPageUri: 'https://twowaychat-99605114.hs-sitesqa.com/sample-offer',
  systemOnline: true,
  type: 'V1',
  metadata: { '@type': 'V1_META' },
  showPreviousConversations: true
};

var WIDGET_DATA_PROD = exports.WIDGET_DATA_PROD = {
  '@type': 'V1',
  showingHsBranding: false,
  agentsRestrictedToMaxConcurrentChats: false,
  hasVisitorEmail: false,
  hasVisitorGivenConsentToCommunicate: false,
  hasVisitorGivenConsentToProcess: false,
  sessionId: 'AMOaWbLk8hwxEjwuTLISGJEgdDjoWM0WQDBKFdI_3ZJtecFJlI2PCqCWhXIlZFlk0Z0ICwwQNEL_6ZjJZqBSruFXwRqz77AMDQ8bkMu-hzAzan3lmjxXSKdFBSTiOIjsPwjUp2Q_9xUGDSJfHgG8w4pKNtXyk8UAHBAnoQjCNXw9nsJCgKtd_yIoT0tpUR3i3YTFefIe2L9-',
  launcherType: 'ICON',
  message: {
    id: 25298,
    exclusionListIds: [],
    inclusionListIds: [],
    targetingRules: [{
      sourceType: 'URL',
      matchType: 'EQUALS',
      queryParam: null,
      matchValue: 'http://twowaychatt-4559655.hs-sites.com/sample-offer',
      type: 'INCLUDE',
      createdBy: 'AGENT'
    }, {
      sourceType: 'URL',
      matchType: 'EQUALS',
      queryParam: null,
      matchValue: 'http://www.twowaychatt-4559655.hs-sites.com/sample-offer',
      type: 'INCLUDE',
      createdBy: 'SYSTEM'
    }],
    exclusionUrls: [],
    inclusionUrls: [],
    targetedMessageSource: 'LIVE_CHAT',
    active: true,
    name: 'New Message (May 14, 2018 3:06 PM)',
    initialMessage: 'Have any questions? Happy to help!',
    initialBotResponder: null,
    targetAudienceType: 'ALL_VISITORS',
    rotatingToOwner: null,
    fallbackUser: null,
    targetAudienceId: null,
    showAfterElapsedSeconds: null,
    showOnPercentagePageScroll: null,
    customAwayMessage: "I'm away at the moment, but let me know if you have any questions and I'll reply to you soon.",
    inboxId: 667,
    askForEmailMessage: 'Don’t have time to wait for a response? Leave your email to get notified when we reply.',
    teamName: null,
    aboutTeam: null,
    customEmailCaptureDelay: 60000,
    customConsentToCommunicateMessage: null,
    customConsentToProcessMessage: 'By clicking submit below, you consent to allow twowaychatt.com to store and process the personal information submitted above to provide you the content requested.',
    consentToCommunicateSubscriptionId: null,
    language: 'en',
    chatHeadingConfig: {
      '@type': 'USERS_AND_TEAMS',
      userIds: [5838963],
      teamIds: []
    },
    clientTriggers: {
      displayOnExitIntent: { enabled: false },
      displayOnTimeDelay: { enabled: false, timeDelaySeconds: 7 },
      displayOnScrollPercentage: { enabled: false, scrollPercentage: 50 }
    },
    hideWhenOffline: false,
    popOpenWelcomeMessage: true,
    popOpenWidget: false,
    gdprExplicitConsentRequired: true,
    gdprConsentToProcessEnabled: false,
    gdprConsentToCommunicateEnabled: false,
    captureVisitorEmailAddress: true,
    popMessageOnSmallScreens: true,
    showOnSmallScreens: true,
    portalId: 4559655,
    creatorId: 5838963,
    lastEditorId: null,
    createdAt: 1526324840335,
    lastEditedAt: 1536346780920,
    deletedAt: 0
  },
  availabilityOptions: {
    awayMessage: null,
    typicalResponseTime: null,
    officeHoursStartTime: null
  },
  sendFrom: [],
  botResponder: null,
  gates: {
    'Chatflows:ClientTriggers': false
  },
  accentColor: '#00a4bd',
  customAwayMessage: "I'm away at the moment, but let me know if you have any questions and I'll reply to you soon.",
  companyName: 'two-way-chat',
  teamName: null,
  aboutTeam: null,
  messagesPageUri: 'http://twowaychatt-4559655.hs-sites.com/sample-offer',
  systemOnline: true,
  type: 'V1',
  metadata: { '@type': 'V1_META' },
  showPreviousConversations: true
};

function buildSpeedCurveWidgetData(overrides) {
  var widgetData = _enviro2.default.isQa() ? WIDGET_DATA_QA : WIDGET_DATA_PROD;
  return _extends({}, widgetData, overrides);
}